import { render, staticRenderFns } from "./CurrentTariff.vue?vue&type=template&id=a444f7d8&scoped=true"
import script from "./CurrentTariff.vue?vue&type=script&lang=js"
export * from "./CurrentTariff.vue?vue&type=script&lang=js"
import style0 from "./CurrentTariff.vue?vue&type=style&index=0&id=a444f7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a444f7d8",
  null
  
)

export default component.exports